import AOS from 'aos';
import 'aos/dist/aos.css';
import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);
import 'swiper/css';

AOS.init();

const hamburgers = document.querySelectorAll(".hamburger");
if (hamburgers.length > 0) {
    hamburgers.forEach(function(hamburger) {
        hamburger.addEventListener("click", function() {
            this.classList.toggle("is-active");
            let nav = document.querySelector("header nav")
            nav.classList.toggle("is-active")
        }, false);
    });
}

// 選單
const menuBtns = document.querySelectorAll("header nav ul a[href^='#box'], header nav ul a[href^='#top']")
menuBtns.forEach(function(btn) {
    btn.addEventListener("click", function(e) {
        e.preventDefault()

        document.querySelector(".hamburger").classList.toggle("is-active")
        document.querySelector("header nav").classList.toggle("is-active")

        let h =document.querySelector("header").offsetHeight;

        const href = this.getAttribute("href");
        const offsetTop = document.querySelector(href).offsetTop -h;

        scroll({
            top: offsetTop,
            behavior: "smooth"
        })
    })
})

// 影片
const movBtns = document.querySelectorAll("#movList a");
movBtns.forEach(function(btn) {
    btn.addEventListener("click", function(e) {
        e.preventDefault()
        let ytsrc = 'https://www.youtube.com/embed/' + this.getAttribute("href") + '?autoplay=1';
        let ytbox = document.getElementById("ytmov");
        ytbox.src = ytsrc
        let player = new YT.Player('ytmov')
        console.log(player)
        player.playVideo()
    })
})

var swiper = new Swiper(".swiper", {
    slidesPerView: 1,
    direction: "horizontal",
    spaceBetween: 32,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    }
})

function reportWindowSize() {
    if( window.innerWidth > 998 ) {
        swiper.enable(true)
    } else {
        swiper.enable(false)
    }
}

window.onresize = reportWindowSize
window.onload = reportWindowSize

